import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  ViewChild
} from '@angular/core';
import { SearchModalIconComponent } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AnalyticsDataPopulateService,
  DeviceTypeService,
  FlyoutPositionDirective
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { PushPipe } from '@ngrx/component';
import { BehaviorSubject } from 'rxjs';
import { FlyoutSearchView } from '../../../../data-access/models/interface/search-modal/flyout-search.interfaces';
import { FlyoutSearchWrapperComponent } from '../flyout-search-wrapper/flyout-search-wrapper.component';

@Component({
  selector: 'idp-search-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    SearchModalIconComponent,
    FlyoutSearchWrapperComponent,
    PushPipe,
    FlyoutPositionDirective
  ],
  templateUrl: './search-wrapper.component.html',
  styleUrls: ['./search-wrapper.component.scss']
})
export class SearchWrapperComponent {
  @Input() displaySearchFooter = false;
  @Input() isAlertAdvisory = false;
  @ViewChild('flyoutSearchDesktop') flyoutSearchDesktop!: ElementRef;
  @ViewChild('flyoutSearchMobile') flyoutSearchMobile!: ElementRef;
  analyticsService = inject(AnalyticsDataPopulateService);
  flyoutSearch$ = new BehaviorSubject<boolean>(false);
  show = false;
  showModal: FlyoutSearchView = FlyoutSearchView.Desktop;
  constructor(private deviceTypeService: DeviceTypeService) {}

  @HostListener('window:resize') onResize() {
    if (this.show) {
      if (
        this.deviceTypeService.getDeviceType().isTablet ||
        this.deviceTypeService.getDeviceType().isDesktop
      ) {
        this.showModal = FlyoutSearchView.Desktop;
        this.flyoutSearchMobile?.nativeElement?.close();
        this.flyoutSearchDesktop?.nativeElement?.showModal();
      } else {
        this.showModal = FlyoutSearchView.Mobile;
        this.flyoutSearchDesktop?.nativeElement?.close();
        this.flyoutSearchMobile?.nativeElement?.showModal();
      }
    }
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    if (event.key === 'Escape') {
      this.closeFlyout();
    }
  }

  openFlyoutSearch(): void {
    this.show = true;
    this.flyoutSearch$.next(true);

    const deviceType = this.deviceTypeService.getDeviceType();
    this.showModal =
      deviceType.isTablet || deviceType.isDesktop
        ? FlyoutSearchView.Desktop
        : FlyoutSearchView.Mobile;

    setTimeout(() => {
      if (
        this.deviceTypeService.getDeviceType().isTablet ||
        this.deviceTypeService.getDeviceType().isDesktop
      ) {
        this.flyoutSearchDesktop.nativeElement.showModal();
      } else {
        this.flyoutSearchMobile.nativeElement.showModal();
      }
    });
  }

  closeFlyout(): void {
    this.show = false;
    this.flyoutSearchDesktop?.nativeElement?.close();
    this.flyoutSearchMobile?.nativeElement?.close();
  }

  analyticsEventTracking(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(element);
  }
}
